import { Form } from "react-bootstrap";
import "./LabelAndTextBox.css";
import React, { useState } from "react";
import { Utils } from "../../../utilities/Utils";

interface DateBoxProps {
    title?: string;
    defaultValueFrom?: string | Date;
    defaultValueTo?: string | Date;
    onChangeFrom: (value: Date) => void;
    onChangeTo: (value: Date) => void;
    disabled?: boolean;
}

const DateIntervalBox = ({ defaultValueFrom, defaultValueTo, title, onChangeFrom, onChangeTo, disabled }: DateBoxProps) => {
    // Convert defaultValue to a string if it's a Date.
    const rawDateFrom = defaultValueFrom instanceof Date 
        ? defaultValueFrom.toISOString() 
        : defaultValueFrom;

    const rawDateTo = defaultValueTo instanceof Date 
        ? defaultValueTo.toISOString() 
        : defaultValueTo;

    // If the backend sends the uninitialized date, treat it as empty.
    const sanitizedDateFrom = (rawDateFrom && rawDateFrom.startsWith("0000")) || !Utils.isDateInitialized(rawDateFrom)
        ? ""
        : rawDateFrom;
    
    const sanitizedDateTo = (rawDateTo && rawDateTo.startsWith("0000")) || !Utils.isDateInitialized(rawDateTo)
        ? ""
        : rawDateTo;

    const [submittedDateFrom, setSubmittedDateFrom] = useState(sanitizedDateFrom);
    const [submittedDateTo, setSubmittedDateTo] = useState(sanitizedDateTo);

    return (
        <Form.Group className={disabled ? "disabled" : ""}>
            {title && <Form.Label className="fw-bold fs-5 mt-2">{title + ":"}</Form.Label>}
            <div className="d-flex gap-3 flex-wrap">
                <Form.Control
                    className="date"
                    type="date"
                    style={{ maxWidth: '200px', minWidth: '130px' }}
                    value={submittedDateFrom ? new Date(submittedDateFrom).toLocaleDateString('sv-SE').split('T')[0] : ''}
                    onChange={(event) => {
                        const value = event.target.value;
                        if (value) {
                            // Create a new date from the value. Since the input type is "date",
                            // it gives you a local date string. We convert it to ISO format.
                            const dateObject = new Date(value);
                            const isoDate = dateObject.toLocaleDateString('sv-SE').split('T')[0];
                            setSubmittedDateFrom(isoDate);
                            onChangeFrom(dateObject);
                        } else {
                            setSubmittedDateFrom("");
                        }
                    }}
                    disabled={disabled}
                />
                <Form.Control
                    className="date"
                    type="date"
                    style={{ maxWidth: '200px', minWidth: '130px' }}
                    value={submittedDateTo ? new Date(submittedDateTo).toLocaleDateString('sv-SE').split('T')[0] : ''}
                    onChange={(event) => {
                        const value = event.target.value;
                        if (value) {
                            // Create a new date from the value. Since the input type is "date",
                            // it gives you a local date string. We convert it to ISO format.
                            const dateObject = new Date(value);
                            const isoDate = dateObject.toLocaleDateString('sv-SE').split('T')[0];
                            setSubmittedDateTo(isoDate);
                            onChangeTo(dateObject);
                        } else {
                            setSubmittedDateTo("");
                        }
                    }}
                    disabled={disabled}
                    />
            </div>
        </Form.Group>
    );
};

export default DateIntervalBox;